module.exports = __webpack_public_path__ + "public/static/adminLeftimg.svg?16db9e0a";